"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaIconActionLabelPlacement = exports.LunaIconActionTypes = exports.LunaIconActionSizes = void 0;

var _types, _sizes, _labelPlacement;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __baseClass = 'luna-icon_action';
var __labelBase = '-with_label';
var __iconBase = '--icon';
var LunaIconActionSizes = {
  s10: 's10',
  s20: 's20',
  s30: 's30',
  s40: 's40'
};
exports.LunaIconActionSizes = LunaIconActionSizes;
var LunaIconActionTypes = {
  t5: 't5',
  t10: 't10',
  t20: 't20',
  t30: 't30'
};
exports.LunaIconActionTypes = LunaIconActionTypes;
var LunaIconActionLabelPlacement = {
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  above: 'above'
};
exports.LunaIconActionLabelPlacement = LunaIconActionLabelPlacement;
var classes = {
  base: __baseClass,
  checkbox: "".concat(__baseClass, "--toggle"),
  toggle: "".concat(__baseClass, "--badge"),
  isDisabled: "".concat(__baseClass, "-is_disabled"),
  withLabel: "".concat(__baseClass).concat(__labelBase),
  labelContent: "".concat(__baseClass, "--label"),
  icon: "".concat(__baseClass).concat(__iconBase),
  types: (_types = {}, _defineProperty(_types, LunaIconActionTypes.t5, "".concat(__baseClass, "-5")), _defineProperty(_types, LunaIconActionTypes.t10, "".concat(__baseClass, "-10")), _defineProperty(_types, LunaIconActionTypes.t20, "".concat(__baseClass, "-20")), _defineProperty(_types, LunaIconActionTypes.t30, "".concat(__baseClass, "-30")), _types),
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaIconActionSizes.s10, "".concat(__baseClass, "-size-10")), _defineProperty(_sizes, LunaIconActionSizes.s20, "".concat(__baseClass, "-size-20")), _defineProperty(_sizes, LunaIconActionSizes.s30, "".concat(__baseClass, "-size-30")), _defineProperty(_sizes, LunaIconActionSizes.s40, "".concat(__baseClass, "-size-40")), _sizes),
  labelPlacement: (_labelPlacement = {}, _defineProperty(_labelPlacement, LunaIconActionLabelPlacement.bottom, "".concat(__baseClass).concat(__labelBase, "_below")), _defineProperty(_labelPlacement, LunaIconActionLabelPlacement.right, "".concat(__baseClass).concat(__labelBase, "_right")), _defineProperty(_labelPlacement, LunaIconActionLabelPlacement.left, "".concat(__baseClass).concat(__labelBase, "_left")), _defineProperty(_labelPlacement, LunaIconActionLabelPlacement.above, "".concat(__baseClass).concat(__labelBase, "_above")), _labelPlacement)
};
exports.classes = classes;
